import { render, staticRenderFns } from "./luckywheel.vue?vue&type=template&id=4d923fb0&scoped=true&"
import script from "./luckywheel.vue?vue&type=script&lang=js&"
export * from "./luckywheel.vue?vue&type=script&lang=js&"
import style0 from "./luckywheel.vue?vue&type=style&index=0&id=4d923fb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d923fb0",
  null
  
)

export default component.exports